import type React from "react";
import SimpleNameTable from "../common/SimpleNameTable";
import CreateCustomerForm from "./CreateCustomerForm";
import { TestId } from "../../constants/testIds";

interface Customer {
  _id: string;
  name: string;
}

interface CustomerTableProps {
  items: Customer[];
  loading?: boolean;
  onEdit?: (customerId: string, newName: string) => Promise<void>;
  canEdit?: boolean;
}

const CustomerTable: React.FC<CustomerTableProps> = ({
  items,
  loading,
  onEdit,
  canEdit = false,
}) => {
  return (
    <SimpleNameTable
      items={items}
      loading={loading}
      onEdit={onEdit}
      canEdit={canEdit}
      EditFormComponent={CreateCustomerForm}
      tableTestId={TestId.CUSTOMER.TABLE}
      rowTestId={TestId.CUSTOMER.ROW}
    />
  );
};

export default CustomerTable;
